export const HashAlgorithm = {
  MD5: "md5",
  SHA256: "sha256",
  NONE: "none"
};
